import Widget from '../Widget';

export default class CrownpeakDebug extends Widget {
    init() {
        super.init();
        if (document.cookie.indexOf('crownpeakpreview=1') !== -1) {
            this.ref('self').els[0].style.display = 'block';
        }
    }
}